import { KnowYourCustomerApplication } from '@prisma/client'
import { xhrApiClient } from '@/config/xhrApiClient'
import { TkYCStatus } from '@/src/modules/kyc/types'

export type TApiErrorResponse = {
    error: string
    correlation_id?: string
}

export type IKYCApplicationInfoResult = {
    data: IKYCApplicationInfo
}

export interface IKYCApplicationInfo {
    email: string
    contact_name: string
    company_name: string
    contact_phone: string
    reason_for_interest: string
    website: string
    ein_ssn: string
    address_line1: string
    address_line2: string
    city: string
    state: string
    zip: string
}

export interface IKYCApplicationCreateInfo {
    id: number
    uid: string
    status: TkYCStatus
}

export type TPaginatedKYCApplicationData = {
    limit: number
    offset: number
    count: number
    data: KnowYourCustomerApplication[]
}

const PostKYCApplication = async (
    payload: IKYCApplicationInfo
): Promise<IKYCApplicationCreateInfo | TApiErrorResponse> => {
    return await xhrApiClient.post('/api/kyc-application', payload)
}

export default PostKYCApplication
